export function querify(query) {
  function reducer(reduced, key) {
    let value = query[key];

    if (/_id$/.test(key) || /_ids$/.test(key)) {
      value = String(value) !== String(parseInt(value, 10)) ? null : parseInt(value, 10);

      if (/_ids$/.test(key)) {
        value = value === null ? [] : [value];
      }

      reduced[key] = value;
    } else if (['true', 'false'].includes(key)) {
      reduced[key] = value === 'true';
    } else {
      reduced[key] = value;
    }

    return reduced;
  }

  return Object.keys(query).reduce(reducer, {});
}

export function unequal(a, b) {
  const typeA = typeof a;
  const typeB = typeof b;

  if (typeA === typeB) {
    if (typeA === 'object') {
      if (!a || !b) {
        return a !== b;
      }

      const keys = Object.keys(a);

      if (Array.isArray(a)) {
        if (a.length !== b.length) {
          return true;
        }
      } else {
        keys.push(...Object.keys(b));
      }

      return keys.some(i => unequal(a[i], b[i]));
    }

    return a !== b;
  }

  return String(a) !== String(b);
}

export default function filter(filters, allowed) {
  function reducer(reduced, field) {
    if (Array.isArray(allowed[field]) && !Array.isArray(filters[field])) {
      reduced[field] = [filters[field]];
    } else {
      reduced[field] = filters[field];
    }

    return reduced;
  }

  return Object
    .keys(filters)
    .filter((field) => {
      if (/^CRUDL_/.test(field) || !(field in allowed)) {
        return false;
      }

      if (/^header_/.test(field)) {
        return true;
      }

      return unequal(filters[field], allowed[field]);
    }).reduce(reducer, {});
}
